export default "__VITE_ASSET__pk1joNoz__"